module.exports = __webpack_public_path__ + "img/V15-bg.f8624da8.png";